import React from "react";
import './index.css'

interface hotelBookingsPageProps{
    className?:string
}

export const HotelBookingPage:React.FC<hotelBookingsPageProps> = ({className})=>{
    return(
        <div className={`${className}`}>
            <h3>Hotel Booking Page </h3>
        </div>
    )
}